app.service('shops', function(
	front,
	main,
	shopLocatorView,
	shopsView,
	searchShopView
) {
	function run () {
		switch (front.page()) {
			case 'locator':
				shopLocatorView.init();
			break;
			case 'shops':
				const type = test.getVar('search_shops');

				if (window.location.hash === '#search_shops') {
					$('.search-shop').show();
					searchShopView.init();
				} else if ( !type || type.indexOf('V') === 0 ) {
					shopsView.init();
					$('.search-shop-old').show();
				} else {
					$('.search-shop').show();
					searchShopView.init();
				}
				break;
			break;
			default:
			break;
		}
	}

	function init () {
		run();
	}

	$(document).on('pageChange', () => run());
	main.onLoad(init);
});